import React, {
  createContext,
  useCallback,
  useContext,
  useRef,
  useState,
} from "react";

const ReportExportContext = createContext(null);

export const ReportExportProvider = ({ children }) => {
  const exportHandlerRef = useRef(null);
  const [isExporting, setIsExporting] = useState(false);

  const registerExportHandler = useCallback((fn) => {
    exportHandlerRef.current = fn;
    return () => {
      exportHandlerRef.current = null;
    };
  }, []);

  const handleExport = useCallback(() => {
    exportHandlerRef.current?.();
  }, []);

  const runHandlerRef = useRef(null);
  const [isRunning, setIsRunning] = useState(false);

  // Optional "as at" date (YYYY-MM-DD). Blank/none means no as-at is applied.
  const [asAt, setAsAt] = useState("");
  // True while the as-at field holds text that is not a date. Runs are refused
  // until it is fixed or cleared, so a report never silently runs without it.
  const [isAsAtInvalid, setIsAsAtInvalid] = useState(false);

  const registerRunHandler = useCallback((fn) => {
    runHandlerRef.current = fn;
    return () => {
      runHandlerRef.current = null;
    };
  }, []);

  const handleRun = useCallback(() => {
    runHandlerRef.current?.();
  }, []);

  return (
    <ReportExportContext.Provider
      value={{
        registerExportHandler,
        handleExport,
        isExporting,
        setIsExporting,
        registerRunHandler,
        handleRun,
        isRunning,
        setIsRunning,
        asAt,
        setAsAt,
        isAsAtInvalid,
        setIsAsAtInvalid,
      }}
    >
      {children}
    </ReportExportContext.Provider>
  );
};

export const useReportExportContext = () => useContext(ReportExportContext);
